import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { BsArrowLeft } from 'react-icons/bs';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import PageHeader from '../../components/styled/PageHeader';
import PageHeaderContainer from '../../components/styled/PageHeaderContainer';
import Text from '../../components/styled/Text';
import { colors, PAGE_PATHS } from '../../constants';

const StyledNavContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  padding-left: 32px;
  border-bottom: 1px solid ${colors.grey90};
`;

const Link = styled(Text)`
  min-width: 163.25px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-bottom: ${props =>
    props.color === colors.green && '2px solid' + colors.green};
  cursor: pointer;
`;

const ClientProfileNav = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isChosen, setIsChosen] = useState(0);
  const LINKS = [
    {
      id: 0,
      label: t('client.profile.nav.profile'),
      to: `${PAGE_PATHS.CLIENT_PROFILE.PROFILE}`,
    },
    {
      id: 1,
      label: t('client.profile.nav.address'),
      to: `${PAGE_PATHS.CLIENT_PROFILE.ADDRESS}`,
    },
    {
      id: 2,
      label: t('client.profile.nav.billing'),
      to: `${PAGE_PATHS.CLIENT_PROFILE.BILLING}`,
    },
  ];

  const redirectToJob = () => {
    navigate(PAGE_PATHS.JOB);
  };

  const handleClickLink = link => () => {
    setIsChosen(link.id);
    navigate(link.to);
  };

  return (
    <>
      <PageHeader size="medium">
        <PageHeaderContainer>
          <BsArrowLeft fill={colors.green} onClick={redirectToJob} />
          <Text variant="body-bold">{t('client.profile')}</Text>
        </PageHeaderContainer>
      </PageHeader>
      <StyledNavContainer>
        {LINKS.map(item => (
          <Link
            key={item.id}
            color={item.id === isChosen ? colors.green : colors.navy}
            variant="body-bold"
            onClick={handleClickLink(item)}>
            {item.label}
          </Link>
        ))}
      </StyledNavContainer>
      <Outlet />
    </>
  );
};

export default ClientProfileNav;
